import { css } from "styled-components";
import { datePlaceholderMixin } from "./mixins";
export const riotProductSkin = (chroma, paletteTokens) => css `
  ${chroma.typography.body4};
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    width: 100%;
    padding: 8px 0;
    border: none;
    border-bottom: 1px solid ${paletteTokens.bladetext1_light};
    color: ${paletteTokens.bladetext1_light};
    background-color: ${chroma.input.background};
    cursor: text;
    outline: none;
    ${chroma.typography.display7}

    &::-webkit-calendar-picker-indicator {
      filter: invert(1);
    }

    /* user is typing date */
    &[data-valid="false"]:invalid {
      color: ${paletteTokens.bladetext1};
      border-bottom-color: ${chroma.input.borderInvalid};
    }

    /* date field is fulfilled  */
    &[data-valid="true"]:valid {
      color: ${paletteTokens.bladetext1};
    }
  }

  @supports (-webkit-touch-callout: none) {
    input[data-valid="false"]:valid {
      color: ${chroma.input.placeholder};

      &::before {
        content: "MM/DD/YYYY";
        ${datePlaceholderMixin}
        width: 100%;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map